// extracted by mini-css-extract-plugin
module.exports = {"component":"GalleryView_component___gCaR","productcards":"GalleryView_productcards__bPU_H"};